import { html } from "lit-html";
import { TitledDialog } from "../TitledDialog";

export class MapDialog extends TitledDialog {
	constructor() {
		super();
		this.node.classList.add("dialog--map", "dialog--transparent-header");
	}

	getTemplateHeaderMiddle() {
		return html`<i class="fa fa-map-marker"></i>`;
	}

	getTransparentHeader() {
		return html` <header class="dialog__transparent-header">
				<div class="dialog__transparent-header__text">
					<h1 class="dialog__transparent-header__title ellipsis">
						${this.titleText}
					</h1>
					<h2 class="dialog__transparent-header__subtitle ellipsis">
						${this.subtitleText}
					</h2>
				</div>
			</header>
			<div class="dialog__transparent-header__button">
				<button @click=${this.hide.bind(this)}>
					<span
						class="close-icon close-icon--large close-icon--with-hover"
					></span>
				</button>
			</div>`;
	}
}
